import { useAuth } from 'core/contexts';
import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface IProtectedRoute {
    requiredRoles?: string[];
    children: ReactNode;
}

export const ProtectedRoute = (props: IProtectedRoute): React.JSX.Element => {
    const { hasRequiredRoles } = useAuth();
    const { children, requiredRoles = [] } = props;

    if (requiredRoles.length && !hasRequiredRoles(requiredRoles)) {
        console.error('InsufficientPermissionsError');
        return <Navigate to='/InsufficientPermissionsError' replace />;
    }

    return <>{children}</>;
};
